var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.DAY_OCCURENCE = {
    FIRST: 'FIRST',
    SECOND: 'SECOND',
    THIRD: 'THIRD',
    LAST: 'LAST',
    FOURTH: 'FOURTH'
};

Object.freeze(Enum.MEEDY.DAY_OCCURENCE);